import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { LoginParams, UserData, VERSION } from "../../utils/datatype";
import { encryptData } from "../../utils/util";
type AuthState = {
    userData: UserData | null;
    isAuthenticated: boolean;
    version: string;
}



/**
 * @function initialState - 获取初始化用户信息
 * * 从localStorage中获取用户信息
 * @returns {AuthState} - 返回用户信息 
 */
const initialState: () => AuthState = () => {
    const isAuthenticated = localStorage.getItem('isAuthenticated');
    const version = localStorage.getItem('version');
    const { version: currentVersion } = process.env.VERSION as unknown as VERSION;
    const tempUser = localStorage.getItem('tempUser');
    if(isAuthenticated === null || isAuthenticated === 'false' || version !== currentVersion.toString() && tempUser){
        // 清除localStorage, 保留roi筛选列配置
        const columnCache = localStorage.getItem('columnCache') || '';
        const adjustColumnCache = localStorage.getItem('adjustColumnCache') || '';
        const snapColumnCache = localStorage.getItem('snapColumnCache') || '';
        localStorage.clear();
        localStorage.setItem('columnCache', columnCache);
        localStorage.setItem('adjustColumnCache', adjustColumnCache);
        localStorage.setItem('snapColumnCache', snapColumnCache);
        return {
            userData: null,
            isAuthenticated: false,
            version: '',
            credentials: {} as LoginParams
        };
    }
    // 获取当前用户临时信息
    return {
        userData: JSON.parse(tempUser as string),
        isAuthenticated: true,
        version: currentVersion.toString()
    }
}


/**
 * @function authSlice - 创建用户信息的slice
 * @returns {Slice} - 返回用户信息的slice
 * @param {AuthState} - 用户信息
 * @reducers { setAuthInfo, clearAuthInfo, setUserData } - 设置用户信息，清除用户信息，设置当前用户账号数据
 */
export const authSlice = createSlice({
    name: "auth",
    initialState: initialState(),
    reducers: {
        setAuthInfo: (state, action: PayloadAction<AuthState>) => {
            const { version } = process.env.VERSION as unknown as VERSION;
            localStorage.setItem('isAuthenticated', action.payload.isAuthenticated.toString());
            localStorage.setItem('version', version.toString());
            localStorage.setItem('tempUser', JSON.stringify(action.payload.userData));
            state.userData = action.payload.userData;
            state.isAuthenticated = action.payload.isAuthenticated;
            state.version = version.toString();
        },
        clearAuthInfo: (state) => {
            const columnCache = localStorage.getItem('columnCache') || '';
            const adjustColumnCache = localStorage.getItem('adjustColumnCache') || '';
            const snapColumnCache = localStorage.getItem('snapColumnCache') || '';
            localStorage.clear();
            localStorage.setItem('columnCache', columnCache);
            localStorage.setItem('adjustColumnCache', adjustColumnCache);
            localStorage.setItem('snapColumnCache', snapColumnCache);
            state.userData = null;
            state.isAuthenticated = false;
            state.version = '';
        },

        setUserData: (state, action: PayloadAction<UserData>) => {
            const userData = { ...action.payload, demandAdmin: state.userData?.demandAdmin };
            state.userData = userData;
            localStorage.setItem('tempUser', JSON.stringify(userData));
        }
    }
})

export const { setAuthInfo, clearAuthInfo } = authSlice.actions;

export default authSlice.reducer;
